<script lang="ts">
  /** The proto's `.stat` tile: a big number and a small caption. */
  let {
    value,
    label,
    tone = 'plain',
    big = false,
  }: { value: string; label: string; tone?: 'plain' | 'good' | 'move'; big?: boolean } = $props();
</script>

<div class="stat {tone}" class:big>
  <b class="num">{value}</b>
  <span>{label}</span>
</div>

<style>
  .stat {
    background: var(--viisi-surface);
    border-radius: var(--viisi-radius);
    padding: 12px;
    box-shadow: var(--viisi-shadow);
    min-width: 0;
  }
  .stat b {
    display: block;
    font-family: var(--viisi-font-display);
    font-size: 24px;
    font-weight: 800;
    line-height: 1.1;
  }
  .stat.big b { font-size: 30px; }
  .stat span { font-size: 11.5px; color: var(--viisi-ink-2); font-weight: 600; }
  .stat.move b { color: var(--viisi-move); }
  .stat.good b { color: var(--viisi-good); }
</style>
